import { cloneDeep } from 'lodash';

const state = {
  catalog_pages: [],
  catalog_page: {},
  edit_catalog_page: {},
  filter: {}
};

const getters = {
  catalog_pages: (state) => {
    return state.catalog_pages || [];
  },
  catalog_page: (state) => {
    return state.catalog_page || {};
  },
  edit_catalog_page: (state) => {
    return state.edit_catalog_page || {};
  },
  filter: (state) => {
    return state.filter || {};
  }
};

const mutations = {
  SET_CATALOG_PAGES(state, list) {
    state.catalog_pages = list;
  },
  SET_CATALOG_PAGE(state, item) {
    state.catalog_page = cloneDeep(item);
    state.edit_catalog_page = cloneDeep(item);

    var index = state.catalog_pages.findIndex((x) => x.id === item.id);
    if (index >= 0) {
      this._vm.$set(state.catalog_pages, index, item);
    }
  },
  EDIT_CATALOG_PAGE(state, item) {
    state.edit_catalog_page = cloneDeep(item);
  },
  SET_FILTER(state, item) {
    state.filter = cloneDeep(item);
  }
};

const actions = {
  getCatalogPages({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('catalogPages/getCatalogPages')
        .then((response) => {
          commit('SET_CATALOG_PAGES', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getCatalogPage({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`catalogPages/getCatalogPage?id=${id}`)
        .then((response) => {
          commit('SET_CATALOG_PAGE', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateCatalogPage({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('catalogPages/updateCatalogPage', req)
        .then((response) => {
          commit('SET_CATALOG_PAGE', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  set({ commit }, req) {
    commit('SET_CATALOG_PAGE', req);
  },
  edit({ commit }, item) {
    commit('EDIT_CATALOG_PAGE', item);
  },
  setFilter({ commit }, item) {
    commit('SET_FILTER', item);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
